<template>
  <div>
    <h1 class="index-sub-title">
      概况
    </h1>
    <div class="flex_column jump_btn">
      <a
        href="http://zljk.baiten.cn"
        target="_blank"
        title="专利大数据服务系统"
      >
        <label class="round">P</label>
        <span>专利大数据服务系统</span> 
      </a>
      <a
        href="http://tmjk.baiten.cn"
        target="_blank"
        title="商标大数据服务系统"
      >
        <label class="round">T</label>
        <span>商标大数据服务系统</span> 
      </a>
    </div>
    <div class="top flex_row">
      <div class="flex_column">
        <border-div
          :width="301"
          :height="171"
        >
          <shadow-box :show-data="showData1" />
        </border-div>
        <border-div
          :width="301"
          :height="171"
        >
          <bar-line-chart
            :list="list1.data"
            :is-legend="true"
            :series-type="['line']"
            :title="list1.title"
            :color="list1.color"
            :style-mixs="list1.styleMixs"
          />
        </border-div>
        <border-div
          :width="301"
          :height="171"
        >
          <pie-chart
            :list="pie1.data"
            :title="pie1.title"
            :color="pie1.color"
          /> 
        </border-div>             
      </div>
      <div class="top-map">
        <map-chart :map-obj="dnTotalList" />
      </div>
      <div>
        <shadow-table
          :table-data="tableData"
        />
      </div>         
    </div>
    <h1 class="index-sub-title">
      知识产权类无形资产
    </h1>
    <div class="flex_column">
      <div class="unit flex_row">
        <border-div
          :width="267"
          :height="96"
        >
          <shadow-box :show-data="showData21" />
        </border-div>
        <border-div
          :width="267"
          :height="96"
        >
          <shadow-box :show-data="showData22" />
        </border-div>
        <border-div
          :width="267"
          :height="96"
        >
          <shadow-box :show-data="showData23" />
        </border-div>
        <border-div
          :width="267"
          :height="96"
        >
          <shadow-box :show-data="showData24" />
        </border-div>
        <border-div
          :width="267"
          :height="96"
        >
          <shadow-box :show-data="showData25" />
        </border-div>
      </div>
      <div class="unit flex_row">
        <border-div
          :width="554"
          :height="299"
        >
          <bar-line-chart 
            :list="ipDnTotalList.data" 
            :is-legend="false" 
            :reverse="false" 
            :series-type="['bar']" 
            :color="ipDnTotalList.color" 
            :title="ipDnTotalList.title"
            :is-show-label="false"
          />
        </border-div>
        <border-div
          :width="842"
          :height="299"
        >
          <bar-line-chart
            :list="list2.data"
            :is-legend="true"
            :series-type="['line']"
            :title="list2.title"
            :color="list2.color"
          />
        </border-div>
      </div>
      <div class="unit flex_row">
        <border-div
          :width="696"
          :height="277"
        >
          <bar-line-chart
            :list="ipAuthorList.data"
            :is-legend="false"
            :reverse="true"
            :series-type="['bar']"
            :color="ipAuthorList.color"
            :title="ipAuthorList.title"
          />
        </border-div>
        <border-div
          :width="696"
          :height="277"
        >
          <pie-chart
            :list="pie2.data"
            :title="pie2.title"
            :color="pie2.color"
          /> 
        </border-div>
      </div>
    </div>     
    <h1 class="index-sub-title">
      标准计量类无形资产
    </h1>
    <div class="flex_column">
      <div class="unit flex_row">
        <border-div
          :width="296"
          :height="96"
        >
          <shadow-box :show-data="showData31" />
        </border-div>
        <border-div
          :width="1106"
          :height="96"
        >
          <shadow-box
            :show-data="showData32"
            :show-average="true"
          />
        </border-div>      
      </div>
      <div class="unit flex_row">
        <border-div
          :width="696"
          :height="277"
        >
          <bar-line-chart
            :list="stAuthorList.data"
            :is-legend="false"
            :reverse="true"
            :series-type="['bar']"
            :color="stAuthorList.color"
            :title="stAuthorList.title"
          />
        </border-div>
        <border-div
          :width="696"
          :height="277"
        >
          <pie-chart
            :list="pie3.data"
            :title="pie3.title"
            :color="pie3.color"
          /> 
        </border-div>        
      </div>
      <div class="unit">
        <border-div
          :width="1418"
          :height="277"
        >
          <bar-line-chart
            :list="list3.data"
            :is-legend="true"
            :series-type="['line']"
            :title="list3.title"
            :color="list3.color"
          />
        </border-div>
      </div> 
    </div>        
    <h1 class="index-sub-title">
      质量&认证认可类无形资产
    </h1>
    <div class="flex_column">
      <div class="unit flex_row">
        <border-div
          :width="296"
          :height="96"
        >
          <shadow-box :show-data="showData41" />
        </border-div>
        <border-div
          :width="1106"
          :height="96"
        >
          <shadow-box
            :show-data="showData42"
            :show-average="true"
          />
        </border-div>      
      </div>
      <div class="unit flex_row">
        <border-div
          :width="696"
          :height="277"
        >
          <bar-line-chart
            :list="qaAuthorList.data"
            :is-legend="false"
            :reverse="true"
            :series-type="['bar']"
            :color="qaAuthorList.color"
            :title="qaAuthorList.title"
          />
        </border-div>
        <border-div
          :width="696"
          :height="277"
        >
          <pie-chart
            :list="pie4.data"
            :title="pie4.title"
            :color="pie4.color"
          /> 
        </border-div>        
      </div>
      <div class="unit">
        <border-div
          :width="1418"
          :height="277"
        >
          <bar-line-chart
            :list="list4.data"
            :is-legend="true"
            :series-type="['line']"
            :title="list4.title"
            :color="list4.color"
          />
        </border-div>
      </div>
    </div>
  </div>
</template>

<script>
import BarLineChart from './components/BarLineChart'
import PieChart from './components/PieChart'
import MapChart from './components/MapChart'
import ShadowTable from './components/ShadowTable' 
import BorderDiv from './components/BorderDiv'
import ShadowBox from "./components/ShadowBox"
import { mapState } from 'vuex'
import { getAssetsAggData,getAssetsAggEntData} from "@/api/index.js"
export default {
  components: {
    BarLineChart,
    PieChart,
    MapChart,
    ShadowBox,
    ShadowTable,
    BorderDiv
    // ScrollChart,
  },
  data() {
    return {     
      /* 概况 */
      dnTotalList:{},
      tableData:null,
      type1TrendList:[],
      currentYears:[],
      currentTenYears:[],
      list1:{
        data:null,
        title:'发展趋势',
        color:["#55b8e6","#3385d1","#4145b8"],
        styleMixs:{
          lineStyle:{
            width:2
          },
          gridTop:'30%'
        }
      },
      pie1:{
        data:[],
        title:'类型分布',
        color:["#73DDFF","#9E87FF","#FD866A"]
      },
      showData1:[
          {
            name:'知识产权类总量',
            key:'ipCTotal',
            icon:'icon_1',
            value:null,
          },
          {
            name:'标准计量类总量',
            key:'stCTotal',
            icon:'icon_2',
            value:null,
          },
          {
            name:'质量&认证认可总量',
            icon:'icon_5',
            key:'qaCTotal',
            value:null,
          }
      ],

     /* 知识产权类无形资产 */
      showData21:[
        {
          name:'知识产权类总量',
          key:'ipCTotal',
          icon:'icon_3',
          value:null
        },
      ],
      showData22:[
        {
          name:'专利总量',
          key:'patTotal',
          icon:'icon_4',
          value:null
        }
      ],
      showData23:[
        {
          name:'商标总量',
          key:'tmTotal',
          icon:'icon_5',
          value:null
        }
      ],
      showData24:[
        {
          name:'地理标志',
          key:'ilTotal',
          icon:'icon_6',
          value:null
        }
      ],
      showData25:[
          {
            name:'软件著作权',
            key:'swTotal',
            icon:'icon_7',
            value:null
          }
        ],
      ipDnTotalList:{
        data:null,
        title:'知识产权区域分布',
        color:["#7091e5"]
      },
      list2:{
        data:[],
        title:'知识产权申请趋势',
        color:["#73DDFF","#9E87FF","#FD866A","#fdd56a"]
      },
      ipAuthorList:{
        data:[],
        title:'企业知识产权类无形资产数量排行TOP5',
        color:["#7091e5"]
      },
       pie2:{
        data:[],
        title:'类型分布',
        color:["#73DDFF","#9E87FF","#FD866A","#fdd56a"]
      },

      /* 标准计量类无形资产 */
      list3:{
        data:[],
        title:'发展趋势',
        color:["#73DDFF","#9E87FF","#FD866A","#fdd56a"]
      },
      pie3:{
        data:[],
        title:'类型分布',
        color:["#73DDFF","#9E87FF","#FD866A","#fdd56a"]
      },
      stAuthorList:{
        data:[],
        title:'企业标准计量类无形资产数量排行TOP5',
        color:["#7091e5"]
      },
      showData31:[
        {
          name:'标准计量总量',
          icon:'icon_3',
          value:null,
          key:'stCTotal'
        },
      ],
      showData32:[
        {
          name:'标准类总量',
          icon:'icon_4',
          value:null,
          key:"stTotal"
        },
        {
          name:'计量类总量',
          icon:'icon_5',
          value:null,
          key:'meTotal'
        }
        // {
        //   name:'认证认可质量',
        //   icon:'icon_3',
        //   value:null,
        //   key:'qauTotal'
        // }
      ],
      /* 质量&认证认可类无形资产 */
      list4:{
        data:[],
        title:'发展趋势',
        color:["#73DDFF","#9E87FF","#FD866A","#fdd56a"]
      },
      pie4:{
        data:[],
        title:'类型分布',
        color:["#73DDFF","#9E87FF","#FD866A","#fdd56a"]
      },
      qaAuthorList:{
        data:[],
        title:'企业质量类无形资产数量排行TOP5',
        color:["#7091e5"]
      },
      showData41:[
        {
          name:'质量&认证认可总量',
          icon:'icon_3',
          value:null,
          key:'qaCTotal'
        },
      ],
      showData42:[
        {
          name:'质量奖总量',
          icon:'icon_4',
          value:null,
          key:'qawTotal'
        },
        {
          name:'质量信用评价总量',
          icon:'icon_5',
          value:null,
          key:'qcTotal'
        },
        {
          name:'认证认可质量',
          icon:'icon_3',
          value:'3908',
          key:'qauTotal'
        }
      ],
    }
  },
  computed: {
    navLeft() {
      return this.navData.filter(item => item.name === '所有公开商标总量' || item.name === '今年新增申请')
    },
    navCenter() {
      return this.navData.filter(item => item.name === '当前有效商标总量')
    },
    navRight() {
      return this.navData.filter(item => item.name === '今年新增注册' || item.name === '今年急需续展')
    },
    ...mapState({
      areaID: state => state.user.firstLevelAreaID,
      platShortName: state => state.user.platShortName
    })
  },
  mounted() {
    getAssetsAggData().then(res=>{
      let { code,data} = res;
      if(code === 0 && data){
       let {dnTotalList,dnTypeTotalList,type1TrendList,ipDnTotalList,ipTrendList,stTrendList,qaTrendList,fiveYearList,tenYearList} = data;
        this.currentYears = fiveYearList;
        this.currentTenYears = tenYearList;
        // // eslint-disable-next-line no-debugger
        /* 概况 */
        this.dnTotalList = Object.assign({},{platform:'jiangdu'},{data:dnTotalList.map(item=>{
          return {
            name: item.dn,
            value:item.typeCount
          }
        }) 
      })      
        this.tableData  = dnTypeTotalList.map(item=>{
          return {
            street:item.dn,
            patNo:item.patCount,
            trademark:item.tmCount,
            standard:item.stCount,
            regard:item.authCount,
            total:item.totalCount
          }
        });
        let general = this.getListData(type1TrendList);
        this.list1.data = this.currentYears.map((item,index)=>{
          return {
              name:item,
              data:[
                { name:'知识产权类',value: general['知识产权类'].list[index]},
                { name:'标准计量类资产',value:general['标准计量类资产'].list[index] },
                { name:'质量类',value:general['质量类'].list[index]  }
              ] 
            }
        })
        this.pie1.data = [
          {name:'知识产权类',value:general['知识产权类'].sum},
          {name:'标准计量类资产',value:general['标准计量类资产'].sum},
          {name: '质量类',value:general['质量类'].sum},
        ],
        this.showData1.forEach(item=>{
           item.value = this.getItemValue(item.key,data)
        })
        this.showData21[0].value = this.getItemValue(this.showData21[0].key,data);
        this.showData22[0].value = this.getItemValue(this.showData22[0].key,data);
        this.showData23[0].value = this.getItemValue(this.showData23[0].key,data);
        this.showData24[0].value = this.getItemValue(this.showData24[0].key,data);
        this.showData25[0].value = this.getItemValue(this.showData25[0].key,data);
        /* 知识产权类 */
      this.ipDnTotalList.data = [ipDnTotalList.map(item=>{
        return {
          name: item.dn,
          value: item.typeCount
        }
      })]      
      let zscq = this.getListData(ipTrendList);     
      this.list2.data = this.currentTenYears.map((item,index)=>{
          return {
              name:item,
              data:[
                // { name:'知识产权类',value: zscq['知识产权类'].list[index]},
                { name:'专利',value:  zscq['专利'].list[index]},
                { name:'商标',value: zscq['商标'].list[index]},
                { name:'地理标志',value: zscq['地理标志'].list[index] },
                { name:'软件著作权',value: zscq['软件著作权'].list[index]},
              ] 
          }
        })
      this.pie2.data = [
          // { name:'知识产权类',value:zscq['知识产权类'].sum},
          { name:'专利',value:zscq['专利'].sum},
          { name:'商标',value:zscq['商标'].sum},
          { name:'地理标志',value:zscq['地理标志'].sum},
          { name:'软件著作权',value:zscq['软件著作权'].sum}
        ]
     
        /* 标准计量类 */   
        let standard = this.getListData(stTrendList); 
        const typeNames = stTrendList.map(item => item.typeName);  
        const filteredData = typeNames.filter(item => item !== "标准计量类资产");  
        this.list3.data = this.currentTenYears.map((item,index)=>{
          const data=filteredData.map(item2=>{
            return {
              name:item2,
              value:standard[item2].list[index]
            }
          })
          return {
              name:item,
              data:data
              // data:[
              //   { name:'参与制定标准',value:standard['参与制定标准'].list[index]},
              //   // { name:'标准计量类资产',value:standard['标准计量类资产'].list[index]},
              //   { name:'计量管理体系',value:standard['计量管理体系'].list[index]},
              //   { name:'计量技术规范',value:standard['计量技术规范'].list[index]}
              // ] 
          }
        })
        this.pie3.data=filteredData.map(item=>{
          return {
            name:item,
            value:standard[item].sum
          }
        })
        // this.pie3.data = [
        //   { name:'参与制定标准',value:standard['参与制定标准'].sum},
        //   // { name:'标准计量类资产',value:standard['标准计量类资产'].sum},
        //   { name:'计量管理体系',value:standard['计量管理体系'].sum},
        //   { name:'计量技术规范',value:standard['计量技术规范'].sum}
        // ]
        this.showData31[0].value = this.getItemValue(this.showData31[0].key,data)
        this.showData32.forEach(item=>{
           item.value = this.getItemValue(item.key,data)
        })
        /* 质量&认证认可类无形资产 */
        let zlzr = this.getListData(qaTrendList);     
        this.list4.data = this.currentTenYears.map((item,index)=>{
          return {
              name:item,
              data:[
                // { name:'质量类',value: zlzr['质量类'].list[index]},
                { name:'认证认可',value: zlzr['认证认可'].list[index] },
                { name:'质量奖',value:zlzr['质量奖'].list[index] },
                // { name:'工业质量信用等级',value:zlzr['工业质量信用等级'].list[index] }
              ] 
          }
        })
        this.pie4.data = [
          // { name:'质量类',value: zlzr['质量类'].sum},
          { name:'认证认可',value: zlzr['认证认可'].sum},
          { name:'质量奖',value:zlzr['质量奖'].sum },
          // { name:'工业质量信用等级',value:zlzr['工业质量信用等级'].sum}
        ]        
        this.showData41[0].value = this.getItemValue(this.showData41[0].key,data);
        this.showData42.forEach(item=>{
           item.value = this.getItemValue(item.key,data)
        })
      }
    })

    getAssetsAggEntData().then(res=>{
      let data = res.data;
      if(data){
          let {ipAuthorList,stAuthorList,qaAuthorList} = data;
          this.ipAuthorList.data = [ipAuthorList.filter(item=>item.author && item.typeCount).map(item=>{
          return {
              name:item.author,
              value:item.typeCount
          }
        }).sort((a,b)=>a.value-b.value)]
         this.stAuthorList.data = [stAuthorList.filter(item=>item.author && item.typeCount).map(item=>{
          return {
              name:item.author,
              value:item.typeCount
          }
        }).sort((a,b)=>a.value - b.value)]
        this.qaAuthorList.data = [qaAuthorList.filter(item=>item.author && item.typeCount).map(item=>{
          return {
              name:item.author,
              value:item.typeCount
          }
        }).sort((a,b)=>a.value - b.value)]
      }
    })
  },
  methods: {
    getItemValue(key,data){
        switch(key){
        case "ipCTotal": return data.ipCTotal;
        case "patTotal": return data.patTotal;
        case "tmTotal": return data.tmTotal;
        case "ilTotal": return data.ilTotal;
        case "swTotal": return data.swTotal;
        case "stCTotal": return data.stCTotal;
        case "stTotal":  return data.stTotal;
        case "meTotal":  return data.meTotal;
        case "qaCTotal": return data.qaCTotal;
        case "qcTotal":  return data.qcTotal;
        case "qawTotal": return data.qawTotal;
        case "qauTotal": return data.qauTotal;
      }
    },
    getListData(list){
      return list.reduce((cur,item)=>{
         cur[item.typeName] = {
            list:item.typeCountList,
            sum: item.typeCountList.reduce((cur,item)=>{return cur+item})
         }
         return cur;
      },{})
    },
    load() {
      this.loadLeft()
      // this.loadRight()
      // this.loadNav()
      // this.loadCenter()
    },
    loadLeft() {
  
    },
    loadRight() {
      // getTrends({ trendType: 'apply' }).then(res => {
      //   this.applyTrends.push(this.getData(res))
      // })
      // getTrends({ trendType: 'register' }).then(res => {
      //   this.registerTrends.push(this.getData(res))
      // })
      // getTradeMarkKeep().then(res => {
      //   this.tradeMarkKeep.push(this.getData(res))
      // })
      // getCommodityCategory().then(res => {
      //   this.commodityCategory.push(this.getData(res))
      // })
      // getTradeMarkKeepShowing().then(res => {
      //   this.tradeMarkKeepShowing.push(this.getData(res))
      // })
      // getTradeMarkTransfer().then(res => {
      //   this.tradeMarkTransfer.push(this.getData(res))
      // })
    },
    loadNav() {
      // getCountInfo().then(res => {
      //   const { code, result } = res
      //   if (code === 200 && result.length > 0) {
      //     this.navData = result
      //   }
      // })
    },
    loadCenter() {
      this.map.platform = this.platShortName
      // this.map.platform = 'jiangdu'
      if (this.areaID) {
        // getMap({ areaID: this.areaID }).then(res => {
        //   const { code, result } = res
        //   if (code === 200 && result && result.length > 0) {
        //     this.map.data = result.map(item => {
        //       const { name, data } = item
        //       return {
        //         value: data.find(it => it.name === '合计').value,
        //         name
        //       }
        //     })
        //   }
        // })
      }
    },
    getData(res) {
      const { code, result } = res
      if (code === 200 && result && result.length > 0) {
        return result.map(parent => {
          return this.getJson(parent)
        })
      }
    },
    getJson(parent) {
      if (Array.isArray(parent)) {
        return parent.map(item => {
          return this.getFormater(item)
        })
      } else {
        return this.getFormater(parent)
      }
    },
    getFormater(item) {
      return {
        name: item.name,
        value: parseInt(item.value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .unit{
    margin-top:10px;
    display:flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .top{
    justify-content: space-between;
    >div:first-child{
      justify-content: space-between;
    }
    .top-map{
      flex:1;
      div{
        width:100%;
        height:100%;
      }
    }
  }
  .jump_btn{
    position: fixed;
    top:50%;
    left:20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;   
    z-index:9;
   >a{
      background:url("../../assets/images/jumpImg.png");
      color:#fff;
      width: 206px;
      height: 52px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 40px 0;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;
     .round{
        width: 40px;
        height: 40px;
        border-radius: 45%;
        background-color: #365a92;
        color: #fff;
        font-size: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        margin-right:20px;
     } 
     span{
        font-size: 14px;
        color: #ABBEF1;
        font-weight:bold;
     } 
     &:hover{
       text-decoration: none;
     } 
   }
  }
  
</style>
